import { CHARGING_CATEGORY_NAME } from './constants';
const useHasChargingItem = (fields) => {
    var _a, _b, _c;
    const hasChargingItem = (_c = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.some(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(CHARGING_CATEGORY_NAME.toLocaleLowerCase()); });
    return !!hasChargingItem;
};
export default useHasChargingItem;
